// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"55":"3dc12ed3","210":"5b56fdf8","244":"24a49787","412":"8b9d430d","667":"27d870a9","861":"1f0a34d0","945":"c21ddf38"}[chunkId] + ".css";
};